import type { UserRole } from '@/types/user';

interface UserRoleBadgeProps {
  role: UserRole;
}

const roleStyles: Record<UserRole, string> = {
  Admin: 'bg-blue-500/20 text-blue-400 border-blue-500/30',
  Operator: 'bg-gray-500/20 text-gray-400 border-gray-500/30',
};

export function UserRoleBadge({ role }: UserRoleBadgeProps) {
  return (
    <span
      className={`px-2 py-1 text-xs font-medium rounded border ${roleStyles[role]}`}
    >
      {role}
    </span>
  );
}
